import React from 'react'
import "./LoadingPage.css"

const LoadingPage = () => {
  return (
    <div className='loader-container'>
      <div className="loader"></div>
      <h2>Загрузка</h2>
    </div>
  )
}

export default LoadingPage